var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalisationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41669 26.0417C6.70835 22.6563 0.666687 14.5834 0.666687 10C0.666687 4.47921 5.09377 4.12464e-05 10.6667 4.12464e-05C16.1875 4.12464e-05 20.6667 4.47921 20.6667 10C20.6667 14.5834 14.5729 22.6563 11.8646 26.0417C11.2396 26.823 10.0417 26.823 9.41669 26.0417ZM10.6667 13.3334C12.4896 13.3334 14 11.875 14 10C14 8.17712 12.4896 6.66671 10.6667 6.66671C8.79169 6.66671 7.33335 8.17712 7.33335 10C7.33335 11.875 8.79169 13.3334 10.6667 13.3334Z",
    fill: "#C10100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalisationIcon);
export default __webpack_public_path__ + "static/media/localisation_icon.48ffed331df0f915524a0ff88d720ec3.svg";
export { ForwardRef as ReactComponent };